import template from './cadastralReferenceForm.html';
import controller from './cadastralReferenceForm.controller';
import './cadastralReferenceForm.scss';

let cadastralReferenceFormComponent = {
  restrict: 'E',
  bindings: {
    simulation: '<',
    loan: '<',
    loanResponseId: '<',
    tempLoanObject: '<',
    isMobileApp: '<',
    onSave: '&',
    showModalQuestion: '&',
    onChangeForm: '&',
  },
  template,
  controller
};

export default cadastralReferenceFormComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/cadastralReferenceForm/cadastralReferenceForm.component.js